module.exports = __webpack_public_path__ + "img/entrance.965caccc.png";